import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import TransactionReviewTab from "components/TransactionReviewTab";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import { getCompany } from "state/slices/company";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import HistoryTransactionReview from "components/HistoryTransactionReview";

const TransactionReview = () => {
  const { trxId, companyId } = useParams();
  const dispatch = useDispatch();
  const urlString = window.location.search; // Gets the query string part of the URL
  const urlParams = new URLSearchParams(urlString);
  const isViewMode = false;
  const { transactionUnderReview, getTransactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const [status, setStatus] = useState(getTransactionUnderReview.status);
  useEffect(() => {
    dispatch(
      getTransactionUnderReviewAsync({
        trxId,
      })
    );
  }, [trxId]);

  useEffect(() => {
    setStatus(getTransactionUnderReview.status);
  }, [getTransactionUnderReview.status]);

  if (status === "loading") {
    return (
      <>
        <CompanyDashboardWrapper>
          <SpinnerIcon />
        </CompanyDashboardWrapper>
      </>
    );
  }
  if (
    status === "succeeded" &&
    transactionUnderReview?.items?.transactions?.length > 0
  ) {
    if (
      transactionUnderReview.items.transactions.some((trx) => trx?.isForHistory)
    ) {
      return (
        <div>
          <CompanyDashboardWrapper>
            {<HistoryTransactionReview isViewMode={isViewMode} />}
          </CompanyDashboardWrapper>
        </div>
      );
    }
    return (
      <div>
        <CompanyDashboardWrapper>
          {<TransactionReviewTab isViewMode={isViewMode} />}
        </CompanyDashboardWrapper>
      </div>
    );
  }
  if (status === "failed") {
    return (
      <>
        <span>Failed to get resources..</span>
      </>
    );
  }
  return <span>Idle...</span>;
};

export default TransactionReview;
